export const headersConfigs = {
    appVersion: process.env.REACT_APP_VERSION,
    appTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};
